import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { DriversComponent } from './drivers/drivers.component';
import { UsersComponent } from './users/users.component';
import { TripsComponent } from './trips/trips.component';
import { PaymentsComponent } from './payments/payments.component';
import { DriverDetailComponent } from './driver-detail/driver-detail.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { TripDetailComponent } from './trip-detail/trip-detail.component';
import { SettingsComponent } from './settings/settings.component';
import { CitiesComponent } from './cities/cities.component';
import { ShopsComponent } from './shops/shops.component';
import { FaresComponent } from './fares/fares.component';
import { CarCategoriesComponent } from './car-categories/car-categories.component';
import { CarsComponent } from './cars/cars.component';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchPipe } from './search.pipe';
import { FilterPipe } from './filterpipe.pipe';
 import * as firebase from 'firebase';
 import { NgxGeoautocompleteModule } from 'ngx-geoautocomplete';
import { WithdrawlsComponent } from './withdrawls/withdrawls.component';
 import { ToastrModule, ToastNoAnimation, ToastNoAnimationModule } from 'ngx-toastr';
 //import { NgxEditorModule } from 'ngx-editor';
 import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
 import { NgxLoadingModule } from 'ngx-loading';
import { PaymentSettingsComponent } from './payment-settings/payment-settings.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { TicketsComponent } from './tickets/tickets.component';
import { TicketDetailsComponent } from './ticket-details/ticket-details.component';
import { AdminsComponent } from './admins/admins.component';
import { CreateAdminComponent } from './create-admin/create-admin.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AddUserComponent } from './add-user/add-user.component';
import { DriverRequestsComponent } from './driver-requests/driver-requests.component';
import { PendingRequestsComponent } from './pending-requests/pending-requests.component';
import { CarRequestsComponent } from './pending-requests/car-requests/car-requests.component';
import { PayoutRequestsComponent } from './pending-requests/payout-requests/payout-requests.component';

import { NgxDocViewerModule } from 'ngx-doc-viewer';

var firebaseConfig = {
  apiKey: "AIzaSyDXCg5oFwUjjw4Lkt8tzyZ7w0rr0qmUbwc",
  authDomain: "ambit-51f75.firebaseapp.com",
  databaseURL: "https://ambit-51f75.firebaseio.com",
  projectId: "ambit-51f75",
  storageBucket: "ambit-51f75.appspot.com",
  messagingSenderId: "675119914848",
  appId: "1:675119914848:web:37c68ccfa2b3ac26fd0805",
  measurementId: "G-8RBYWM4829"
};
firebase.initializeApp(firebaseConfig);

const appRoutes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'home', component: HomeComponent },
  { path: 'view-admins', component: AdminsComponent },
  { path: 'create-admin', component: CreateAdminComponent },
  { path: 'drivers', component: DriversComponent },
  { path: 'pending-requests', component: PendingRequestsComponent},
  { path: 'driver-requests', component: DriverRequestsComponent },
  { path: 'users', component: UsersComponent },
  { path: 'trips', component: TripsComponent },
  { path: 'payments', component: PaymentsComponent },
  { path: 'payouts', component: WithdrawlsComponent },
  { path: 'driver-detail', component: DriverDetailComponent },
  {path: 'driver-detail/:id', component: DriverDetailComponent},
  { path: 'user-detail', component: UserDetailComponent },
  {path: 'user-detail/:id', component: UserDetailComponent},
  { path: 'trip-detail/:id', component: TripDetailComponent },
  { path: 'ticket-detail/:id', component: TicketDetailsComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'cities', component: CitiesComponent },
  { path: 'stops', component: ShopsComponent },
  { path: 'fares', component: FaresComponent },
  { path: 'tickets', component: TicketsComponent },
  { path: 'notifications', component: NotificationsComponent },
  { path: 'payment-settings', component: PaymentSettingsComponent },
  { path: 'car-categories', component: CarCategoriesComponent },
  { path: 'cars', component: CarsComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    HomeComponent,
    DriversComponent,
    UsersComponent,
    TripsComponent,
    PaymentsComponent,
    DriverDetailComponent,
    UserDetailComponent,
    TripDetailComponent,
    SettingsComponent,
    CitiesComponent,
    ShopsComponent,
    FaresComponent,
    CarCategoriesComponent,
    CarsComponent,
    SearchPipe,
    FilterPipe,
    WithdrawlsComponent,
    PaymentSettingsComponent,
    NotificationsComponent,
    TicketsComponent,
    TicketDetailsComponent,
    AdminsComponent,
    CreateAdminComponent,
    ResetPasswordComponent,
    AddUserComponent,
    DriverRequestsComponent,
    PendingRequestsComponent,
    CarRequestsComponent,
    PayoutRequestsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CKEditorModule,
    ReactiveFormsModule,
    NgxDocViewerModule,
   NgxGeoautocompleteModule.forRoot(),
   NgxLoadingModule.forRoot({
    fullScreenBackdrop: true,
    backdropBorderRadius: '3px'
  }),
    ToastNoAnimationModule.forRoot(),
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
